module.exports = __webpack_public_path__ + "assets/img/abhijit-khan-germany.bd37621f.jpg";